module.exports = __webpack_public_path__ + "img/yjbx.318c43b4.png";